import React from 'react';
import { defaultTemplate } from 'core/hoc';

const PrintAdditionalDocumentsTemplate = ({
	t,
	printAdditionalDocumentsViewStore: { modalParams, options, selectedType, selectType, print },
}) => {
	return (
		<section>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.PRINTADDITIONALDOCUMENTSMODAL.TITLE')}</h3>
			</div>
			<div className="ReactModal__body">
				{options.map(option => {
					const id = `printAdditionalDocument-${option.type}`;
					return (
						<div key={option.type} className="form__group__label spc--bottom--sml">
							<input
								id={id}
								name="printAdditionalDocument"
								type="radio"
								className="input--radio"
								checked={selectedType === option.type}
								onChange={() => selectType(option.type)}
								data-cy={id}
							/>
							<label htmlFor={id}>{t(option.label)}</label>
						</div>
					);
				})}
			</div>
			<div className="ReactModal__footer">
				<button
					className="btn btn--med btn--primary spc--right--sml spc--bottom--sml"
					type="button"
					onClick={print}
					data-cy="printAdditionalDocument"
				>
					{t('FULFILLMENTORDER.PRINTADDITIONALDOCUMENTSMODAL.PRINT')}
				</button>
				<button className="btn btn--med btn--secondary spc--bottom--sml" type="button" onClick={modalParams.close}>
					{t('BACK')}
				</button>
			</div>
		</section>
	);
};

export default defaultTemplate(PrintAdditionalDocumentsTemplate);
